export default {
    // Default state can be overriden/supplied by the backend via VuexService class.
    state: {
        apps: [],
    },

    mutations: {
        updateApp(state, app) {
            let appIndex = state.apps.findIndex(a => a.name == app.name);
            state.apps[appIndex] = {...app};
        },
    
        removeApp(state, app) {
            state.apps = state.apps.filter(a => a.name != app.name);
        }
    },

    actions: {

    },

    getters: {
        findAppByName: (state) => (appName) => {
            if (state.apps && state.apps.length > 0) {
                let app = state.apps.find(app => app.name == appName);

                if (!app) {
                    console.error(`[apps/findAppByName] App "${appName}" not found. Make sure you spelt it correctly.`);
                }

                return app;
            }

            return null;
        },

        isAppAvailable: (state, getters) => (appName) => {
            let app = getters.findAppByName(appName);

            return app && app.available;
        },

        isAppEnabled: (state, getters) => (appName) => {
            let app = getters.findAppByName(appName);

            return app && app.enabled;
        },

        allAvailableApps: (state) => {
            return state.apps.filter(app => app.available);
        },

        allEnabledApps: (state) => {
            return state.apps.filter(app => app.enabled);
        },

        allDisabledApps: (state) => {
            return state.apps.filter(app => !app.enabled);
        },
    }
}
